import residentialPropertyMarketingCampaigns from '@/assets/img/users-cases/residential-property-marketing-campaigns.webp';
import residentialPropertyMarketingCampaignsHow from '@/assets/img/users-cases/residential-property-marketing-campaigns-how.webp';
import residentialPropertyMarketingCampaignsResult from '@/assets/img/users-cases/residential-property-marketing-campaigns-result.webp';

export default {
  slug: 'residential-property-marketing-campaigns',
  order: 26,
  title: '2D & 3D Floor Plan',
  subtitle: 'Generating professional 2D and 3D floor plans for residential property marketing campaigns.',
  tags: ['AIFloorPlan', 'PropertyMarketing'],

  images: {
    hero: residentialPropertyMarketingCampaigns,
    aboutTop: residentialPropertyMarketingCampaignsHow,
    aboutBottom: residentialPropertyMarketingCampaignsResult,
  },

  howText:
    'Architectural drawings were uploaded into the floor plan creator AI, which automatically generated accurate 2D floor plans. These plans were then transformed into detailed 3D layouts ready for marketing brochures, online listings, and virtual walkthroughs, allowing consistent visual content across all units.',

  resultText:
    'The combination of 2D and 3D floorplan AI tools allowed the developer to produce accurate 2D floor plans for every unit, visually rich 3D home models, and interactive 360° tours. These assets were reused across multiple marketing campaigns, cutting approval time and increasing overall efficiency while attracting more prospective buyers online.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
